import { Component, ViewChild } from "@angular/core";
import { Config } from "../../core/DefaultConfig";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { DeleteModel } from "../../core/models/dele.model";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { AddEditWorkFlowStepComponent } from "./add-edit-work-flow-step/add-edit-work-flow-step.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatGridListModule } from "@angular/material/grid-list";
import { TranslateModule } from "@ngx-translate/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AppUrlConstants } from "../../core/constants/AppUrlConstants";
import { ApplicationDataService } from "../../core/services/application-data.service";
import { GenericCrudService } from "../../core/services/generic-crud.service";
import { AlertDialogComponent } from "../../shared/alert-dialog/alert-dialog.component";
import { DeleteDialogComponent } from "../../shared/delete-dialog/delete-dialog.component";
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getCustomPaginatorIntl } from "../../shared/paginator.helper";

@Component({
  selector: "app-work-flow-steps",
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    TranslateModule,
  ],
  templateUrl: "./work-flow-steps.component.html",
  styleUrls: ["./work-flow-steps.component.css"],
  providers: [
    { provide: MatPaginatorIntl, useValue: getCustomPaginatorIntl('Workflows per page') }
  ],
})
export class WorkFlowStepsComponent {
  displayedColumns: string[] = ["orderBy", "name", "description", "action"];
  config = new Config();

  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  dataList: any[] = [];
  segments: any[] = [];
  deleteModel: DeleteModel = {
    title: "DROP_WORK_FLOW_TITLE",
    message: "WORK_FLOW_STEP_DROP_MESSAGE",
    deleteButtonText: "DROP",
    cancelButtonText: "CALCEL",
  };
  defaultProcess: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    public dialog: MatDialog,
    private crudService: GenericCrudService,
    private appDataService: ApplicationDataService
  ) {
    this.dataSource = new MatTableDataSource();
    this.dataSource.sortingDataAccessor = (item, property) => {
      const value = item[property];
      return typeof value === "string" ? value.toLowerCase() : value;
    };
  }
  ngOnInit() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      const value = item[property];
      return typeof value === "string" ? value.toLowerCase() : value;
    };
    this.appDataService.getAllSegments().subscribe({
      next: (res: any) => {
        this.segments = res?.data;
      },
    });
    this.getBySegment(1);
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getBySegment(id: number) {
    this.appDataService.getAllWorkFlowStepsBySegment(id).subscribe({
      next: (res: any) => {
        // Update the data in the existing MatTableDataSource
        this.dataSource.data = res?.data || [];
        // Attach paginator and sort
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        // Add case-insensitive sorting logic
        this.dataSource.sortingDataAccessor = (item, property) => {
          const value = item[property];
          return typeof value === "string" ? value.toLowerCase() : value;
        };

        // Find the default process
        this.defaultProcess = this.dataSource.data.find(
          (status) => status?.processType === "DEFAULT_PROCESS"
        );
      },
      error: (e) => {
        console.error("Error fetching data:", e);
      },
    });
  }
  add() {
    const dialogRef = this.dialog.open(AddEditWorkFlowStepComponent, {
      data: {
        existingDefaultProcessId: this.defaultProcess?.complaintProcessId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  edit(updateRecord: any, rowNumber: number) {
    const dialogRef = this.dialog.open(AddEditWorkFlowStepComponent, {
      data: {
        ...updateRecord,
        existingDefaultProcessId: this.defaultProcess?.complaintProcessId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  delete(deleteRecord: any, rowNumber: number) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: this.deleteModel,
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.crudService
          .delete(
            deleteRecord?.complaintProcessId,
            AppUrlConstants.COMPLAINT_PROCESS_URL
          )
          .subscribe({
            next: (res: any) => {
              this.dataSource = new MatTableDataSource(res?.data);
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
            },
            error: (e) => {
              if (e?.status == 409) {
                if (e?.error?.errors !== null) {
                  for (const property in e.error.errors) {
                    this.openAlert(e.error.errors[property]);
                  }
                } else {
                  this.openAlert(e?.error?.message);
                }
              }
            },
          });
      }
    });
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: "OK",
        },
      },
    });
  }
}
